import styled from 'styled-components';
import { Title as BaseTitle } from '../titles';
import { FontSize18, FontSize14, FontSize16, FontFamilyMedium, FontFamilyBold, FontSize10, FontFamilyRegular, FontSize12 } from '../fonts';
import { LabelButtonStyle } from '../Buttons/style';
import { ButtonGradient } from '../Buttons';
import { MarginTop20 } from '../margins';
import { TextBlock } from '../text';

export const Container = styled.div`
    width: 100%;
    ${props => props.isMobile && 'overflow-y: auto; height: 100%; padding-bottom: 50px;'};
`;

export const ContentContainer = styled.div`

`;

export const Title = styled(BaseTitle)`
    ${FontSize18};
    text-align: center;
`;

export const OfferShortDescription = styled(TextBlock)`
    text-align: center;
    line-height: 22px;
    margin-top: 4px;
    font-size: 14px;
`;

export const PricingTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 22px 0 14px 0;
`;

export const PricingTitleContainerTitle = styled.p`
    ${FontSize16};
    ${FontFamilyMedium};
    margin: 0;
`;

export const PricingTitleValidUntilDescription = styled.p`
    margin: 0;
    ${FontSize12};
`;

export const PricingTitleValidUntilValue = styled.span`
    ${FontFamilyBold};
`;

export const PricingContainer = styled.div`
    position: relative;
    padding: 6px 19px 15px 19px;
    border-radius: 20px;
    background-color: white;
    border: solid 2px ${props => props.borderColor};
    margin-bottom: 20px;
`;

export const PricingTitle = styled.p`
    color: ${props => props.theme.color[props.themeColor]};
    margin: 0;
    ${FontFamilyBold};
    ${FontSize16};
`;

export const PricingSubtitle = styled.p`
    margin: 0;
    color: ${props => props.theme.color.darkBlue};
    ${FontSize10};
    margin-bottom: 14px;
`;

export const OfferTypeText = styled.p`
    ${FontFamilyBold};
    font-size: 12px;
    margin: 0;
    color: ${props => props.theme.color.darkBlue};
`;

export const OfferTypeDivider = styled.div`
    height: 1px;
    margin-top: 2px;
    margin-bottom: 14px;
    background-color: ${props => props.color};
`;

export const OfferRowContainer = styled.div`
    margin-top: 8px;
`;

export const OfferRowWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const OfferRowLabel = styled.p`
    margin: 0;
    ${FontFamilyRegular};
    ${FontSize14};
    color: ${props => props.theme.color.darkBlue};
`;

export const OfferRowPrice = styled.p`
    margin: 0;
    ${FontFamilyBold};
    color: ${props => props.theme.color.darkBlue};
    ${FontSize16};
`;

export const OfferRowOldPrice = styled.p`
    margin: 0;
    ${FontSize12};
    color: ${props => props.theme.color.darkBlue};
    opacity: 0.9;
    text-align: right;
    text-decoration: line-through;
`;

export const BenefitTitle = styled.p`
    ${FontFamilyMedium};
    color: ${props => props.theme.color.darkBlue};
    margin: 0 0 12px 0;
    font-size: 16px;
`;


export const BenefitIconWrapper = styled.div`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

export const BenefitWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    & > p {
        margin-left: 20px;
    }
`;

export const BenefitText = styled(TextBlock)`
    max-width: 160px;
    color: ${props => props.textColor ? 
        props.theme.color[props.textColor] : props.theme.color.darkBlue
    };
`;

export const Separator = styled.div`
    width: 100%;
    height: 2px;
    border: solid 1px rgba(0, 0, 0, 0.1);
    margin: 11px 0;
`;

export const OfferChangeTypeContainer = styled.div`
    margin-top: 18px;
`;

export const OfferChangeTypeDescription = styled.p`
    margin: 0 0 2px 0;
    ${FontFamilyRegular};
    color: ${props => props.theme.color.darkBlue};
    ${FontSize12};
    text-align: center;
`;

export const OfferChangeTypeAction = styled.button`
    border: none;
    width: 100%;
    padding: 0;
    margin: 0;
    ${FontFamilyRegular};
    color: ${props => props.theme.color.darkBlue};
    text-transform: uppercase;
    text-decoration: underline;
    ${FontSize12};
    text-align: center;
    background-color: white;

    &:hover {
        cursor: pointer;
    }
    &:focus {
        outline: none;
    }
`;

export const CallMeLabel = styled(LabelButtonStyle)`
    ${FontSize14};
`;

export const CallMeButton = styled(ButtonGradient)`
    ${MarginTop20};
`;